import { useTranslation } from 'react-i18next';
import Footer from '@/components/feature/Footer';
import HeroSection from './sections/HeroSection';
import SearchBrowseSection from './sections/SearchBrowseSection';
import ValueCards from './sections/ValueCards';
import CategoriesSection from './sections/CategoriesSection';
import AiPreviewSection from './sections/AiPreviewSection';
import QuotationProcess from './sections/QuotationProcess';
import CtaSection from './sections/CtaSection';
import NewsletterCTA from './sections/NewsletterCTA';

export default function Home() {
  const { t } = useTranslation('home');

  return (
    <div className="min-h-screen bg-white">
      <main>
        <HeroSection />
        <SearchBrowseSection />
        <ValueCards />
        <CategoriesSection />
        <AiPreviewSection />
        <QuotationProcess />
        <CtaSection />
        <NewsletterCTA />
      </main>
      <Footer />
    </div>
  );
}